import { format } from "date-fns";
import { hi } from "date-fns/locale";
import parse from "date-fns/parse";
import getDate from "date-fns/getDate";
import React from "react";
import { Text, View } from "react-native";

import t from "@constants/localization";

const PATH = "components/LGL/PreviousMonthStats";

const getFormattedDate = (dateString) => {
  if (!dateString) return "";
  const parsedDate = parse(dateString, "yyyy-MM-dd", new Date());
  return `${format(parsedDate, "LLLL", { locale: hi })} ${getDate(parsedDate)}`;
};

const PreviousMonthStats = ({ widget = {} }) => {
  if (Object.keys(widget).length === 0 && widget.constructor === Object) {
    return null;
  }

  return (
    <View
      style={{
        backgroundColor: "white",
        borderRadius: 10,
        paddingHorizontal: 15,
        paddingVertical: 20,
        marginTop: 10,
        elevation: 1,
      }}
    >
      <Text
        style={{
          fontFamily: "NotoSansDevanagari-Bold",
          fontSize: 16,
        }}
      >
        {t(`${PATH}/previousMonthStats`)}
      </Text>
      <Text
        style={{
          opacity: 0.56,
          marginVertical: 5,
        }}
      >
        {getFormattedDate(widget?.start_date)} -{" "}
        {getFormattedDate(widget?.end_date)}{" "}
      </Text>
      <View>
        {widget && Array.isArray(widget.points)
          ? widget.points.map((point) => (
              <Text style={{ marginTop: 5 }}>
                <Text style={{ fontFamily: "NotoSansDevanagari-Bold" }}>•</Text>{" "}
                {parsePoint(point)}
              </Text>
            ))
          : null}
      </View>
    </View>
  );
};

const parsePoint = (point) => {
  if (!point) return null;
  let bold = false;
  return point.split(" ").map((word) => {
    if (word.startsWith("**")) {
      bold = true;
    }
    const TextComponent = (
      <Text
        style={{
          fontFamily: bold
            ? "NotoSansDevanagari-Bold"
            : "NotoSansDevanagari-Regular",
        }}
      >
        {word.replace(/\*\*/g, "")}{" "}
      </Text>
    );
    if (word.endsWith("**")) {
      bold = false;
    }
    return TextComponent;
  });
};

export default PreviousMonthStats;
